import { render, staticRenderFns } from "./corporatePage.vue?vue&type=template&id=4d147a5b&scoped=true&"
import script from "./corporatePage.vue?vue&type=script&lang=js&"
export * from "./corporatePage.vue?vue&type=script&lang=js&"
import style0 from "./corporatePage.vue?vue&type=style&index=0&id=4d147a5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d147a5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VImg,VLayout})
